<div class="customer_tab">
  <h2>Leads</h2>
  <mat-tab-group
    animationDuration="0ms"
    (selectedTabChange)="onTabChange($event)"
  >
    <mat-tab label="All Leads">
      <fury-leads-table
        [displayedColumns]="displayedColumns"
        [dataSource]="dataSource"
        [editorAccess]="editorAccess"
      ></fury-leads-table>
      <mat-paginator
        *ngIf="this.totalCount > 0"
        [pageSizeOptions]="[5, 30, 50, 100, 9999]"
        [pageSize]="pageSize"
        [length]="totalCount"
        [pageIndex]="pageIndex"
        (page)="pageSizeChange($event)"
        showFirstLastButtons
        [selectConfig]="selectConfig"
        [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </mat-tab>
    <mat-tab label="Active leads">
      <fury-leads-table
        [displayedColumns]="displayedColumns"
        [dataSource]="dataSource"
        [editorAccess]="editorAccess"
      ></fury-leads-table>
      <mat-paginator
        *ngIf="this.totalCount > 0"
        [pageSizeOptions]="[5, 30, 50, 100, 9999]"
        [pageSize]="pageSize"
        [length]="totalCount"
        [pageIndex]="pageIndex"
        (page)="pageSizeChange($event)"
        showFirstLastButtons
        [selectConfig]="selectConfig"
        [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </mat-tab>
    <mat-tab label="Closed Leads">
      <fury-leads-table
        [displayedColumns]="displayedColumns"
        [dataSource]="dataSource"
        [editorAccess]="editorAccess"
      ></fury-leads-table>
      <mat-paginator
        *ngIf="this.totalCount > 0"
        [pageSizeOptions]="[5, 30, 50, 100, 9999]"
        [pageSize]="pageSize"
        [length]="totalCount"
        [pageIndex]="pageIndex"
        (page)="pageSizeChange($event)"
        showFirstLastButtons
        [selectConfig]="selectConfig"
        [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </mat-tab>
    <mat-tab label="Billable Leads">
      <fury-leads-table
        [displayedColumns]="displayedColumns"
        [dataSource]="dataSource"
        [editorAccess]="editorAccess"
      ></fury-leads-table>
      <mat-paginator
        *ngIf="this.totalCount > 0"
        [pageSizeOptions]="[5, 30, 50, 100, 9999]"
        [pageSize]="pageSize"
        [length]="totalCount"
        [pageIndex]="pageIndex"
        (page)="pageSizeChange($event)"
        showFirstLastButtons
        [selectConfig]="selectConfig"
        [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </mat-tab>
    <mat-tab label="Not Billable Leads">
      <fury-leads-table
        [displayedColumns]="displayedColumns"
        [dataSource]="dataSource"
        [editorAccess]="editorAccess"
      ></fury-leads-table>
      <mat-paginator
        *ngIf="this.totalCount > 0"
        [pageSizeOptions]="[5, 30, 50, 100, 9999]"
        [pageSize]="pageSize"
        [length]="totalCount"
        [pageIndex]="pageIndex"
        (page)="pageSizeChange($event)"
        showFirstLastButtons
        [selectConfig]="selectConfig"
        [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </mat-tab>
  </mat-tab-group>
</div>
